/*
    <div class="input-quantity">
        <button type="button" class="btn btn-minus" tabindex="-1" data-direction="-1" data-update="" disabled=""></button>
        <input type="number" class="input-number" name="rooms" value="1" min="1" max="4" disabled="">
        <button type="button" class="btn btn-plus" tabindex="-1" data-direction="1" data-update=""></button>
    </div>
*/

class InputQuantity {
    constructor(elem) {
        this.elem = elem;
        this.$elem = $(this.elem);

        // input name treba definirati u data atribut: data-inputName="rooms" i data-inputName="bathrooms"
        this.inputName = this.$elem.attr('data-inputName');
        this.inputLabel = this.$elem.attr('data-inputLabel') || this.inputName;

        this.min = this.$elem.attr('data-min') ? +this.$elem.attr('data-min') : 0;
        this.max = this.$elem.attr('data-max') ? +this.$elem.attr('data-max') : 99;
        
        // u biti current value se moze uzeti iu url-a
        this.currentValue = this.$elem.attr('data-currentValue') ? +this.$elem.attr('data-currentValue') : this.min;

        //this.$elem.html(this.renderInputQuantity());
        $(this.renderInputQuantity()).appendTo(this.$elem);
        this.checkUpdateBtns(this.currentValue);
        
        this.$inputNumber = this.$elem.find('input');
        this.$inputNumber.trigger('change');

        this.$inputNumber.on('change', e => {
            const $target = $(e.currentTarget);
            const value = +$target.val();
            this.currentValue = value;
            this.checkUpdateBtns(value);
        });

        this.$elem.find('[data-update]').on('click', e => {
            const $target = $(e.currentTarget);
            const direction = +$target.attr('data-direction');
            let value = +this.$inputNumber.val();

            value = value + direction;
            this.$inputNumber.val(value).trigger('change');
        });

    }

    checkUpdateBtns = (value) => {
        this.$elem.find('button[data-direction="-1"]').prop('disabled', value == this.min || value < this.min);
        this.$elem.find('button[data-direction="1"]').prop('disabled', value == this.max || value > this.max);
    }

    renderInputQuantity = () => {
        return `
            <div class="input-quantity">
                <button type="button" class="btn btn-minus" tabindex="-1" data-direction="-1" data-update></button>
                <label class="invisible" style="width: 0;" for="${ this.inputName }">${ this.inputLabel }</label>
                <input type="number" class="input-number" name="${ this.inputName }" value="${ this.currentValue }" min="${ this.min }" max="${ this.max }" placeholder="${ this.min }" disabled />
                <button type="button" class="btn btn-plus" tabindex="-1" data-direction="1" data-update></button>
            </div>
        `;
    }

}

export {
    InputQuantity
};